import { fetchPatientInfo } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { FetchPatientInfoResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';
import { ENV, logger } from '@/shared';

import { createLotusRequestConfig } from './client';

/**
 * Fetch Patient Info for a user. Returns response.data directly.
 */
export async function fetchPatientInfoByUserId(
  userId: string,
  signal?: AbortSignal
): Promise<FetchPatientInfoResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPatientInfo(userId, config);
  const data = response.data;

  if (!ENV.isProduction) {
    logger.info('patient info fetched', {
      source: 'shared/api/lotus/patientInfo',
      patientInfo: data?.patientInfo,
    });
  }

  return data;
}
